function parseUrlValue(param_name) {
	let parsed_value = false;
	const value = new URLSearchParams(location.search).get(param_name);
	if ( value ) {
		try {
			parsed_value = JSON.parse(value);
		} catch (e) {
			parsed_value = [ value ];
		}
	}
	return parsed_value;
}

function buildUrlValue(value) {
	let url_value = '';
	if ( value.length === 1 ) {
		url_value = value[0];
	} else if ( value.length > 1 ) {
		url_value = JSON.stringify(value);
	}
	return url_value;
}

function setUrlValue(key, value, ...other_pairs) {
	const url = new URL(window.location.href);
	url.searchParams.set(key,  buildUrlValue(value));
	let state = history.state || { };
	state[key] = [...value];
	if ( other_pairs && other_pairs.length > 0 ) {
		other_pairs.forEach( pair => {
			if ( pair && pair.length > 1 ) {
				url.searchParams.set(pair[0], buildUrlValue(pair[1]));
				state[pair[0]] = [...pair[1]];
			}
		} );
	}
	history.pushState(state, document.title, url.toString());
}

module.exports = {
	parseUrlValue,
	buildUrlValue,
	setUrlValue,
};
